import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BackButton from "../../Components/BackButton";
import { Success, Error } from "../../Components/Modal";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import { getCancellationReasonDetails, editCancellationReason } from "../../Services/CancellationReason";
import CancellationReasonForm from "./Components/CancellationReasonForm";
import "../CMSManagement/CMSManagement.css";
import "../../styles/PremiumCardPages.css";

export default function EditCancellationReason() {
    const navigate = useNavigate();
    const { id } = useParams();

    const { data: reasonData, isLoading: isFetching } = useQuery(
        ["get-reason", id],
        () => getCancellationReasonDetails(id)
    );
    const reasonDetail = reasonData?.data?.data?.docs?.[0] || reasonData?.data?.data;

    const { register, handleSubmit, formState: { errors }, control, reset } = useForm({
        defaultValues: {
            status: "true",
            userType: "user",
        },
    });

    useEffect(() => {
        if (reasonDetail) {
            reset({
                id: reasonDetail._id,
                reason: reasonDetail.reason,
                userType: reasonDetail.userType || "user",
                status: String(reasonDetail.status),
            });
        }
    }, [reasonDetail, reset]);

    const { mutate, isLoading } = useMutation(editCancellationReason, {
        onSuccess: (res) => {
            Success("Reason Updated", res.data?.message || "Cancellation reason has been updated successfully.");
            navigate("/cancellation-management");
        },
        onError: (err) => {
            Error(err?.response?.data?.message || "Failed to update reason.");
        },
    });

    return (
        <div className="app-content content pform-page">
            <div className="content-wrapper">
                <div className="content-body">
                    <section id="edit-cancellation-reason">
                        <div className="user-details-wrapper">
                            <div className="pform-page-header">
                                <div className="pform-page-header__row">
                                    <BackButton />
                                    <h1 className="pform-page-header__title">Edit Cancellation Reason</h1>
                                </div>
                                <p className="pform-page-header__subtitle">
                                    Update reason text, audience, and visibility settings
                                </p>
                            </div>

                            <div className="pform-shell">
                                {isFetching ? (
                                    <div className="pform-loading">
                                        <div className="pform-loading__spinner" />
                                        <span>Loading reason data...</span>
                                    </div>
                                ) : (
                                    <CancellationReasonForm
                                        register={register}
                                        handleSubmit={handleSubmit}
                                        errors={errors}
                                        control={control}
                                        onSubmit={(data) => mutate(data)}
                                        isLoading={isLoading}
                                        isEdit
                                    />
                                )}
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
